export const getLandingContainer = (): HTMLDivElement =>
{
	const landingContainer = document.querySelector(".landing-container.section-gap")
	return landingContainer! as HTMLDivElement
}